(function(){
  function initQuadCard(card){
    if(!card || card.dataset.quadReady === '1') return;
    card.dataset.quadReady = '1';

    var buttons = card.querySelectorAll('.mm-choice');
    var cta = card.querySelector('[data-quad-cta]');
    var priceOutput = card.querySelector('[data-quad-price-output]');
    var image = card.querySelector('[data-quad-image]');

    buttons.forEach(function(btn){
      btn.addEventListener('click', function(){
        buttons.forEach(function(otherBtn){
          otherBtn.classList.remove('is-active');
          otherBtn.setAttribute('aria-pressed','false');
        });

        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed','true');

        var url = btn.getAttribute('data-quad-url');
        var selectedPrice = btn.getAttribute('data-quad-price');
        var selectedLabel = btn.getAttribute('data-quad-label');
        var selectedImage = btn.getAttribute('data-quad-image-url');

        if(priceOutput && selectedPrice){
          priceOutput.textContent = selectedPrice;
        }

        if(cta && url){
          cta.href = url;
          cta.textContent = 'Bekijk ' + selectedLabel + ' set';
          cta.removeAttribute('aria-disabled');
        }

        if(image && selectedImage){
          image.src = selectedImage;
          image.alt = 'Quad Lock MAG ' + selectedLabel + ' set';
        }
      });
    });
  }

  function initAllQuadCards(){
    document.querySelectorAll('[data-quad-card]').forEach(function(card){
      initQuadCard(card);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAllQuadCards);
  } else {
    initAllQuadCards();
  }

  document.addEventListener('shopify:section:load', initAllQuadCards);
})();
